import {
  Shield, ShieldCheck, Star, Award, Trophy, Target, Zap, Rocket, Calculator,
  Megaphone, ArrowDownCircle,
} from "lucide-react";
import { cn } from "@/lib/utils";

const ICONS = {
  "shield": Shield,
  "shield-check": ShieldCheck,
  "star": Star,
  "award": Award,
  "trophy": Trophy,
  "target": Target,
  "zap": Zap,
  "rocket": Rocket,
  "calculator": Calculator,
  "megaphone": Megaphone,
  "arrow-down-circle": ArrowDownCircle,
  "whistle": Award, // no whistle icon; reuse Award
};

const TONE_CLASSES = {
  success: "bg-[hsl(var(--success))]/15 text-[hsl(var(--success))] ring-[hsl(var(--success))]/30",
  info: "bg-[hsl(var(--info))]/15 text-[hsl(var(--info))] ring-[hsl(var(--info))]/30",
  warning: "bg-[hsl(var(--warning))]/20 text-[hsl(var(--warning))] ring-[hsl(var(--warning))]/30",
  primary: "bg-primary/15 text-primary ring-primary/30",
  accent: "bg-accent/15 text-accent ring-accent/40",
};

export function BadgeChip({ badge, className, size = "sm" }) {
  const Icon = ICONS[badge.icon] || Star;
  const tone = TONE_CLASSES[badge.tone] || TONE_CLASSES.primary;
  return (
    <span
      title={badge.label}
      data-testid={`badge-${badge.id}`}
      className={cn(
        "inline-flex items-center gap-1 rounded-full ring-1 ring-inset font-medium",
        size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs",
        tone,
        className
      )}
    >
      <Icon className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} />
      {badge.label}
    </span>
  );
}

export function BadgeList({ badges = [], max = 6, size = "sm", className }) {
  if (!badges || badges.length === 0) return null;
  const visible = badges.slice(0, max);
  const extra = badges.length - visible.length;
  return (
    <div className={cn("flex flex-wrap gap-1.5", className)} data-testid="badge-list">
      {visible.map((b) => (
        <BadgeChip key={b.id} badge={b} size={size} />
      ))}
      {extra > 0 && (
        <span className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium bg-muted text-muted-foreground">
          +{extra} more
        </span>
      )}
    </div>
  );
}
